<template>
    <v-checkbox v-model="params.value" class="rtls-checkbox" disabled />
</template>

<script>
export default {
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
